export interface USStatesListItem {
    title: string;
    value: string;
    type: string;
}

export const USStatesList: USStatesListItem[] = [
    {
        title: 'Alabama',
        value: 'AL',
        type: 'State'
    },
    {
        title: 'Alaska',
        value: 'AK',
        type: 'State'
    },
    {
        title: 'Arizona',
        value: 'AZ',
        type: 'State'
    },
    {
        title: 'Arkansas',
        value: 'AR',
        type: 'State'
    },
    {
        title: 'California',
        value: 'CA',
        type: 'State'
    },
    {
        title: 'Colorado',
        value: 'CO',
        type: 'State'
    },
    {
        title: 'Connecticut',
        value: 'CT',
        type: 'State'
    },
    {
        title: 'Delaware',
        value: 'DE',
        type: 'State'
    },
    {
        title: 'District of Columbia',
        value: 'DC',
        type: 'State'
    },
    {
        title: 'Florida',
        value: 'FL',
        type: 'State'
    },
    {
        title: 'Georgia',
        value: 'GA',
        type: 'State'
    },
    {
        title: 'Hawaii',
        value: 'HI',
        type: 'State'
    },
    {
        title: 'Idaho',
        value: 'ID',
        type: 'State'
    },
    {
        title: 'Illinois',
        value: 'IL',
        type: 'State'
    },
    {
        title: 'Indiana',
        value: 'IN',
        type: 'State'
    },
    {
        title: 'Iowa',
        value: 'IA',
        type: 'State'
    },
    {
        title: 'Kansas',
        value: 'KS',
        type: 'State'
    },
    {
        title: 'Kentucky',
        value: 'KY',
        type: 'State'
    },
    {
        title: 'Louisiana',
        value: 'LA',
        type: 'State'
    },
    {
        title: 'Maine',
        value: 'ME',
        type: 'State'
    },
    {
        title: 'Maryland',
        value: 'MD',
        type: 'State'
    },
    {
        title: 'Massachusetts',
        value: 'MA',
        type: 'State'
    },
    {
        title: 'Michigan',
        value: 'MI',
        type: 'State'
    },
    {
        title: 'Minnesota',
        value: 'MN',
        type: 'State'
    },
    {
        title: 'Mississippi',
        value: 'MS',
        type: 'State'
    },
    {
        title: 'Missouri',
        value: 'MO',
        type: 'State'
    },
    {
        title: 'Montana',
        value: 'MT',
        type: 'State'
    },
    {
        title: 'Nebraska',
        value: 'NE',
        type: 'State'
    },
    {
        title: 'Nevada',
        value: 'NV',
        type: 'State'
    },
    {
        title: 'New Hampshire',
        value: 'NH',
        type: 'State'
    },
    {
        title: 'New Jersey',
        value: 'NJ',
        type: 'State'
    },
    {
        title: 'New Mexico',
        value: 'NM',
        type: 'State'
    },
    {
        title: 'New York',
        value: 'NY',
        type: 'State'
    },
    {
        title: 'North Carolina',
        value: 'NC',
        type: 'State'
    },
    {
        title: 'North Dakota',
        value: 'ND',
        type: 'State'
    },
    {
        title: 'Ohio',
        value: 'OH',
        type: 'State'
    },
    {
        title: 'Oklahoma',
        value: 'OK',
        type: 'State'
    },
    {
        title: 'Oregon',
        value: 'OR',
        type: 'State'
    },
    {
        title: 'Pennsylvania',
        value: 'PA',
        type: 'State'
    },
    {
        title: 'Rhode Island',
        value: 'RI',
        type: 'State'
    },
    {
        title: 'South Carolina',
        value: 'SC',
        type: 'State'
    },
    {
        title: 'South Dakota',
        value: 'SD',
        type: 'State'
    },
    {
        title: 'Tennessee',
        value: 'TN',
        type: 'State'
    },
    {
        title: 'Texas',
        value: 'TX',
        type: 'State'
    },
    {
        title: 'Utah',
        value: 'UT',
        type: 'State'
    },
    {
        title: 'Vermont',
        value: 'VT',
        type: 'State'
    },
    {
        title: 'Virginia',
        value: 'VA',
        type: 'State'
    },
    {
        title: 'Washington',
        value: 'WA',
        type: 'State'
    },
    {
        title: 'West Virginia',
        value: 'WV',
        type: 'State'
    },
    {
        title: 'Wisconsin',
        value: 'WI',
        type: 'State'
    },
    {
        title: 'Wyoming',
        value: 'WY',
        type: 'State'
    },
    {
        title: 'American Samoa',
        value: 'AS',
        type: 'Other'
    },
    {
        title: 'Guam',
        value: 'GU',
        type: 'Other'
    },
    {
        title: 'Northern Mariana Islands',
        value: 'MP',
        type: 'Other'
    },
    {
        title: 'Puerto Rico',
        value: 'PR',
        type: 'Other'
    },
    {
        title: 'U.S. Virgin Islands',
        value: 'VI',
        type: 'Other'
    },
    {
        title: 'U.S. Minor Outlying Islands',
        value: 'UM',
        type: 'Other'
    },
    {
        title: 'Marshall Islands',
        value: 'MH',
        type: 'Other'
    },
    {
        title: 'Micronesia',
        value: 'FM',
        type: 'Other'
    },
    {
        title: 'Palau',
        value: 'PW',
        type: 'Other'
    },
    {
        title: 'U.S. Armed Forces (Americas)',
        value: 'AA',
        type: 'Other'
    },
    {
        title: 'U.S. Armed Forces (Europe)',
        value: 'AE',
        type: 'Other'
    },
    {
        title: 'U.S. Armed Forces (Pacific)',
        value: 'AP',
        type: 'Other'
    }
];
